import { format } from "date-fns";
import { ru } from "date-fns/locale";

export default function getFormattedDate(dateStr) {
  return format(new Date(dateStr), "dd MMMM yyyy года", {
    locale: ru,
  });
}
